import { render, staticRenderFns } from "./finans.vue?vue&type=template&id=f2bfedb8&scoped=true&"
import script from "./finans.vue?vue&type=script&lang=js&"
export * from "./finans.vue?vue&type=script&lang=js&"
import style0 from "./finans.vue?vue&type=style&index=0&id=f2bfedb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bfedb8",
  null
  
)

export default component.exports